export default __webpack_public_path__ + "static/collections-bbf11c10aef49ef3ac5e899076f17054.png";